import { type TFunction } from "i18next";

import { type IFrameworkSkill, type IValidationResource, ValidationStatus } from "@sol/sdk";
import type { TagProps } from "@sol/uikit/data-display/Tag/Tag";

import { type SkillLevelItem } from "@/entities/skill";

const getStatus = ({ status, skillLevel }: { skillLevel: number; status: ValidationStatus }): TagProps["color"] => {
    let validatedLevel = 0;
    let unvalidatedLevel = 0;

    if (status === ValidationStatus.VALIDATED && skillLevel > validatedLevel) {
        validatedLevel = skillLevel;
    } else if (skillLevel > unvalidatedLevel) {
        unvalidatedLevel = skillLevel;
    }

    return validatedLevel >= skillLevel ? "success" : unvalidatedLevel >= skillLevel ? "error" : "default";
};

export const getProgressBarLevels = (
    skillLevels: IFrameworkSkill["@id"][],
    validations: Pick<IValidationResource, "status" | "skillLevel">[],
    t: TFunction,
): SkillLevelItem[] =>
    skillLevels.map((skillLevelId, index) => {
        const validation = validations.find(v => v.skillLevel["@id"] === skillLevelId);

        if (!validation) {
            return {
                id: skillLevelId,
                status: "default",
                title: `${t("component.SkillLevel.level")} ${index + 1}`,
            };
        }

        const skillLevel = validation.skillLevel.level;

        return {
            id: skillLevelId,
            status: getStatus({ status: validation.status, skillLevel }),
            title: `${t("component.SkillLevel.level")} ${skillLevel}`,
        };
    });
